import React from 'react';
import Icon from 'components/AppIcon';

const TournamentStatus = ({ tournament, loading }) => {
  if (loading) {
    return (
      <div className="card p-6 animate-pulse">
        <div className="h-4 bg-surface-700 rounded w-1/2 mb-4" />
        <div className="h-20 bg-surface-700 rounded" />
      </div>
    );
  }

  const scores = tournament?.scores || {};
  const scoreEntries = Object.entries(scores)?.sort((a, b) => b?.[1] - a?.[1]);
  const maxScore = scoreEntries?.[0]?.[1] || 1;

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-bold text-foreground flex items-center gap-2">
          <Icon name="Swords" size={18} className="text-accent" />
          Faction Tournament
        </h3>
        <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
          tournament?.status === 'active' ?'bg-success/10 text-success' :'bg-muted/10 text-muted'
        }`}>
          {tournament?.status?.toUpperCase() || 'ACTIVE'}
        </span>
      </div>
      <div className="mb-4">
        <p className="text-sm font-medium text-foreground">{tournament?.tournament_name || 'Season Grand Tournament'}</p>
        <div className="flex items-center gap-2 mt-1">
          <Icon name="DollarSign" size={14} className="text-warning" />
          <span className="text-sm text-warning font-bold">
            ${(tournament?.prize_pool || 500000)?.toLocaleString()} Prize Pool
          </span>
        </div>
      </div>
      {scoreEntries?.length > 0 ? (
        <div className="space-y-2">
          <p className="text-xs text-muted uppercase tracking-wider mb-2">Faction Standings</p>
          {scoreEntries?.slice(0, 5)?.map(([factionName, score], idx) => (
            <div key={factionName}>
              <div className="flex items-center justify-between mb-1">
                <div className="flex items-center gap-2">
                  <span className="text-xs text-muted w-4">#{idx + 1}</span>
                  <span className="text-sm text-foreground">{factionName}</span>
                </div>
                <span className="text-xs font-bold text-primary">{score?.toLocaleString()} pts</span>
              </div>
              <div className="h-1.5 bg-surface-700 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-primary to-accent rounded-full transition-all"
                  style={{ width: `${(score / maxScore) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-6 text-muted">
          <Icon name="Swords" size={28} className="mx-auto mb-2 opacity-30" />
          <p className="text-sm">Tournament in progress</p>
          <p className="text-xs mt-1">Faction scores will appear here</p>
        </div>
      )}
      <div className="mt-4 pt-4 border-t border-border">
        <p className="text-xs text-muted">Winning conditions: Aggregate faction performance (net worth × 0.4 + faction XP × 0.3 + participation × 0.3)</p>
      </div>
    </div>
  );
};

export default TournamentStatus;
